interface DocumentIconProps {
    className?: string;
}

export default function DocumentIcon({
    className = 'w-6 h-6'
}: DocumentIconProps) {
    return (
        <svg
            id="Layer_2"
            data-name="Layer 2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 193.04 211.47"
            className={className}
        >
            <g id="Layer_1-2" data-name="Layer 1">
                <g>
                    <polygon
                        fill="#85171a"
                        points="16.65 78.81 176.39 78.81 193.04 101.95 0 101.95 16.65 78.81"
                    />
                    <g>
                        <path
                            fill="#ebecef"
                            d="M176.39,53.3v130.28c0,15.4-12.49,27.89-27.89,27.89H44.54c-15.4,0-27.89-12.49-27.89-27.89V27.89C16.65,12.49,29.14,0,44.54,0h78.55l53.3,53.3Z"
                        />
                        <path
                            fill="#c1c7cf"
                            d="M176.39,53.3h-44.91c-4.63,0-8.39-3.76-8.39-8.39V0l53.3,53.3Z"
                        />
                    </g>
                    <rect
                        fill="#c1c7cf"
                        x="16.65"
                        y="140.76"
                        width="159.74"
                        height="26.03"
                    />
                    <path
                        fill="#e4262b"
                        d="M193.04,101.95v47.99c0,6.2-5.03,11.23-11.23,11.23H11.23c-6.2,0-11.23-5.03-11.23-11.23v-47.99h193.04Z"
                    />
                    <text
                        fill="#fff"
                        fontFamily="MicrosoftNewTaiLue-Bold, 'Microsoft New Tai Lue'"
                        fontSize="56.56"
                        fontWeight="700"
                        transform="translate(43.59 151.12)"
                    >
                        <tspan x="0" y="0">
                            PDF
                        </tspan>
                    </text>
                </g>
            </g>
        </svg>
    );
}
